import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { VenueKitchenDevicePreferences } from "src/app/shared/models/VenueKitchenDevicePreferences.entity";

@Component({
	selector: "app-kitchen-order-ready-sms-message",
	templateUrl: "./kitchen-order-ready-sms-message.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class KitchenOrderReadySmsMessageComponent implements OnInit {
	@Input() kitchenDevicePreferences: VenueKitchenDevicePreferences;
	@Output() kitchenDevicePreferencesChange = new EventEmitter<VenueKitchenDevicePreferences>();

	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	dragObject: string;

	constructor() {}

	ngOnInit(): void {}

	dragStart(event, item) {
		this.dragObject = item;
	}

	dragEnd(event) {
		this.dragObject = undefined;
	}

	drop(event) {
		this.kitchenDevicePreferences.orderReadySmsMessage += `${this.dragObject}`;
		this.dragObject = undefined;
	}
}
